"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROffice = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Resources_1 = require("../../Resources");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const constants_1 = require("../../constants");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class PROffice extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.PR_OFFICE,
            tags: [Tags_1.Tags.EARTH],
            cost: 7,
            tr: { tr: 1 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.UNITY)),
            metadata: {
                cardNumber: 'T09',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tr(1).br;
                    b.megacredits(1).slash().earth().played;
                }),
                description: 'Requires that Unity are ruling or that you have 2 delegates there. Gain 1 TR. Gain 1 M€ for each Earth tag you have, including this.',
            },
        });
    }
    canPlay(player) {
        const turmoil = player.game.turmoil;
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (turmoil === undefined)
            return false;
        let canAffordReds = true;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            canAffordReds = this.howToAffordReds.canAfford;
        }
        else {
            this.howToAffordReds = undefined;
        }
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.UNITY)) {
            const meetsPartyRequirements = turmoil.canPlay(player, PartyName_1.PartyName.UNITY);
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
                return meetsPartyRequirements && canAffordReds;
            }
            return meetsPartyRequirements;
        }
        let societyCost = player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST;
        if (this.reserveUnits.megacredits > 0)
            societyCost += this.reserveUnits.megacredits;
        Card_1.Card.setSocietyWarningText(this, PartyName_1.PartyName.UNITY);
        return player.canAfford(societyCost);
    }
    play(player) {
        player.increaseTerraformRatingSteps(1);
        const amount = player.getTagCount(Tags_1.Tags.EARTH) + 1;
        player.addResource(Resources_1.Resources.MEGACREDITS, amount);
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.UNITY);
        return undefined;
    }
    getActionDetails(player, card) {
        return new RedsPolicy_1.ActionDetails({
            card: card,
            TRIncrease: 1,
            bonusMegaCredits: player.getTagCount(Tags_1.Tags.EARTH) + 1,
        });
    }
}
exports.PROffice = PROffice;
//# sourceMappingURL=PROffice.js.map